<template>    
        <NuxtLink :to="theLink">
            <div class="featuredpage flex md:block bg-gravaawarmgray">
                <div class="w-1/3 md:w-full ">
                    <UiFeaturedPageImage class="opt1" v-if="page.coverImage && page.coverImage.reference" :mediaData="page.coverImage.reference"
                        :alt="page.title" />
                    <UiFeaturedPageImage class="opt2" v-else-if="page.article && page.article.coverImage && page.article.coverImage.reference" :mediaData="page.article.coverImage.reference"
                    :alt="page.title" />
                    <div class="opt3" v-else-if="page.article && page.article.image && page.article.image.src">                    
                        <UiArticleImage :article="{ title: page.title, image: page.article.image.src}" 
                        :modifiers="{
                        auto: 'format,compress',
                        fit: 'crop',
                        ar: '1:1'                        
                        }"/>                        
                    </div>
                    <div v-else>
                        default image    
                    </div>                    
                    
                </div>
                <div class="textbox w-2/3 md:w-full text-gravaadeepbrown overflow-hidden max-h-28 md:max-h-32">
                    <div class="textboxcontent pt-4 lg:pt-8 pb-0 md:pb-12 px-6 md:px-6 lg:px-8 origin-left">
                        <h3 v-if="!isSmallScreen" v-html="page.title" class="mb-0 md:mb-1 text-2xl xl:text-3xl" />
                        <h4 v-else v-html="page.title" class="mb-0 md:mb-1 text-xl lg:text-2xl" />
                        <p v-if="page.__typename === 'Page'" class="small text-black mb-0" v-html="page.bodySummary?.slice(0, 60) + (page.bodySummary?.length > 60 ? '...' : '')" />
                        <p v-else-if="page.__typename === 'Collection'" class="small text-black mb-0"
                            v-html="page.description?.slice(0, 60) + (page.description?.length > 60 ? '...' : '')" />

                        <p v-else class="small text-black mb-0">
                            {{ page.article?.content?.slice(0, 30) + (page.article?.content?.length > 30 ? '...' : '') }}
                        </p>
                            
                    </div>
                    
                </div>
            </div>
        </NuxtLink>
    
</template>

<script setup>
import { computed } from 'vue';
import { useWindowSize } from '@vueuse/core';

const props = defineProps({
    page: {
        type: Object,
        required: true,
    },

});



const theLink = computed(() => {
    if (props.page.__typename === 'Collection') {
        return `/shop/${props.page.handle}`;
    }
    
    if(props.page?.article){
        return `/blogs/${props.page.article.blog.handle}/${props.page.article.handle}`;
    }

    return `/${props.page.handle}`;
    
    
});

const { width } = useWindowSize();
const isSmallScreen = computed(() => width.value < 397);
</script>

<style scoped>
@reference "../../assets/css/main.css";
    .searchbox h3{
       @apply text-lg; 
    }


    
    h3{
        transition: background-size .2s ease-in-out, padding-bottom .2s .2s ease-in-out;
        background-image: linear-gradient(90deg, #563B2F 0%, #563B2F 100%);
        background-size: 0% 1px;
        background-repeat: no-repeat;
        background-position: 100% 100%;
        display: inline-block;
        padding-bottom: 0px;
        
    }

    .featuredpage:hover h3{
        padding-bottom: 6px;
        background-size: 100% 1px;
        background-position: 0% 100%;
        transition: background-size .2s .2s ease-in-out, padding-bottom .2s ease-in-out;
    }

    

    .featuredpage{
        transition: transform .3s ease, filter .3s ease;
        transform-origin: 50% 50%;
        filter: drop-shadow(0px 0px 0px rgba(0, 0, 0, 0.25));
        
        
    }

    .featuredpage:hover{
        transform: scale(1);
        filter: drop-shadow(0px 0px 8px rgba(0, 0, 0, 0.15));
        
        
    }


</style>